export const BUTTON_GROUP = 'ButtonGroup';
